<template>
  <div id="app">
    <ViewContentLSidebarR :side-bar-status="sideBarToggle.status">
      <div :class="contentClass">
        <div class="text-right d-block d-lg-none sidebarButton">
          <button type="button" class="btn btn-primary" v-on:click="toggleSidebar()">Sidebar <i :class="sideBarToggle.icon"></i></button>
        </div>
        <router-view/>
      </div>
    </ViewContentLSidebarR>
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css'
import SiteFooter from '@/components/SiteFooter'
import ViewContentLSidebarR from '@/components/ViewContentLSidebarR'

export default {
  name: 'App',
  components: {
    SiteFooter,
    ViewContentLSidebarR
  },
  data () {
    return {
      sideBarToggle: {
        status: '',
        icon: 'fas fa-bars fa-fw'
      }
    }
  },
  computed: {
    contentClass: function () {
      if (this.$route.name !== 'Login' && this.$route.name !== 'Login with return') {
        return 'col-12 col-lg-8 col-xl-9'
      } else {
        return 'col-12'
      }
    }
  },
  methods: {
    toggleSidebar: function () {
      if (this.sideBarToggle.status === '') {
        this.sideBarToggle = {
          status: 'active',
          icon: 'fas fa-times fa-fw'
        }
      } else {
        this.sideBarToggle = {
          status: '',
          icon: 'fas fa-bars fa-fw'
        }
      }
    }
  }
}
</script>

<style>
@import url('/assets/fontawesome-all.css');
@import url('/assets/bootstrap.min.css');
@import url('/assets/thinktank.css');
@import url('/assets/thinktank-responsive.css');
@import url('/assets/animations.css');
@import url('/assets/offcanvas.css');
@import url('/assets/print.css');
.router-link-active {
  color: #00508F !important;
}
.featuredImg {
  width: 100%;
}
.featuredImg img {
  max-width: 100%;
  max-height: 100%;
}
.items-per-page {
  display: flex;
  align-items: center;
  float: right;
}
.items-per-page select {
  width: 75px;
  margin-left: 10px;
}
.field-not-validated {
  border: 1px solid orangered;
  padding: 1rem 0 .25rem;
  margin: 0 0 0.5rem;
}
#ddown-right .dropdown-item {
  display: block;
  padding: 0.25rem 1rem;
  background-color: white;
  color: var(--core-txt-color);
  transition: all .35s ease-in-out;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/App.vue